import { get, post, put, remove } from 'communication/httpClient';
import { IGenericObject } from 'types';
import { cleanObject } from 'utils/object';
import {
  LOAD_TAX_RATES,
  TAX_RATES_LOADED,
  SAVE_TAX_RATE,
  TAX_RATE_SAVED,
  TAX_RATE_DELETED,
  RESET_TAX_RATES,
  RESET_SEARCH_TAX_RATES,
  SYNC_FAILED,
  LOAD_TAX_RATE,
  TAX_RATE_LOADED,
  LOAD_TAX_RATES_TYPES,
  SYNC_FAILED_TAX_RATES_TYPES,
  TAX_RATES_TYPES_LOADED,
} from './actionTypes';
import { ITaxRate } from './types';

export const initialActionsState = {
  loadTaxRates: () => {},
  loadTaxRate: () => {},
  saveTaxRate: () => {},
  deleteTaxRate: () => {},
  resetTaxRates: () => {},
  resetSearchTaxRates: () => {},
  loadTaxRatesTypes: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadTaxRates: async (params: IGenericObject) => {
    dispatch({
      type: LOAD_TAX_RATES,
    });

    const { data, error } = await get('/api/tax-rates', { params: cleanObject(params) });

    if (data) {
      dispatch({
        type: TAX_RATES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadTaxRate: async (id: string) => {
    dispatch({
      type: LOAD_TAX_RATE,
    });

    const { data, error } = await get(`/api/tax-rates/${id}`);

    if (data) {
      dispatch({
        type: TAX_RATE_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  saveTaxRate: async (
    taxRate: ITaxRate,
    isNew?: boolean,
    onSuccess?: (taxRate: ITaxRate) => void
  ) => {
    dispatch({
      type: SAVE_TAX_RATE,
    });
    const { rateId = '' } = taxRate || {};
    const handler = isNew ? post : put,
      resourceId = isNew ? '' : rateId;
    const { data, error } = await handler(`/api/tax-rates/${resourceId}`, taxRate);

    if (data || data === '') {
      dispatch({
        type: TAX_RATE_SAVED,
        payload: taxRate,
      });

      if (onSuccess) onSuccess(taxRate);
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  deleteTaxRate: async (id: string, callback?: () => void) => {
    const { data, error } = await remove(`/api/tax-rates/${id}`);
    if (data || data === '') {
      dispatch({
        type: TAX_RATE_DELETED,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetTaxRates: () =>
    dispatch({
      type: RESET_TAX_RATES,
    }),
  resetSearchTaxRates: () =>
    dispatch({
      type: RESET_SEARCH_TAX_RATES,
    }),
  loadTaxRatesTypes: async () => {
    dispatch({
      type: LOAD_TAX_RATES_TYPES,
    });

    const { data, error } = await get('/api/tax-rates/tax-types');

    if (data) {
      dispatch({
        type: TAX_RATES_TYPES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED_TAX_RATES_TYPES,
        payload: error,
      });
    }
  },
});
